// extracted by mini-css-extract-plugin
module.exports = {"rotate":"styles--rotate--JM8vd","vtexSpinnerRotate":"styles--vtex-spinner-rotate--37qg7"};